import { FieldValues, useFormContext, useWatch } from "react-hook-form";
import { APP_SOURCES, FormQuestion } from "vmd-types";

import { SourceQuestionLabel } from "./source-question-label";

function isLlmSuggestedSource(source?: string): boolean {
  return (
    source?.trim().toLowerCase() === APP_SOURCES.LLM_SUGGESTED.toLowerCase()
  );
}

function areSameAnswers(left: unknown, right: unknown): boolean {
  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right)) return false;
    return (
      left.length === right.length &&
      left.every((value, index) => value === right[index])
    );
  }
  return left === right;
}

export function LlmQuestionLabel(props: {
  baseLabel: string;
  fieldName: string;
  isMandatory: boolean;
  question: FormQuestion;
  hasPersistedOverride: boolean;
  initialLlmAnswer: unknown;
}) {
  const {
    baseLabel,
    fieldName,
    isMandatory,
    question,
    hasPersistedOverride,
    initialLlmAnswer,
  } = props;

  const form = useFormContext<FieldValues>();
  const currentValue = useWatch({ control: form.control, name: fieldName });

  const hideLlmSourceOnEdit =
    isLlmSuggestedSource(question.source) &&
    !hasPersistedOverride &&
    initialLlmAnswer !== undefined &&
    !areSameAnswers(currentValue, initialLlmAnswer);

  const source = question.source;
  const showSourceLabel =
    question.showSource &&
    source &&
    !hasPersistedOverride &&
    !hideLlmSourceOnEdit;

  if (!showSourceLabel) {
    return isMandatory ? `${baseLabel} *` : baseLabel;
  }

  return (
    <SourceQuestionLabel
      baseLabel={baseLabel}
      isMandatory={isMandatory}
      source={source}
    />
  );
}
